import { put, takeEvery } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as actionTypes from "./constants";
import { appConfig } from "../../config";
import { push } from "connected-react-router";
var btoa = require("Base64").btoa;

function* fetchexpense(params) {
  let page = (params.params && params.params.page) || 1;
  let search = (params.params && params.params.search) || "";
  let filter = (params.params && params.params.filter) || "";
  let statusFilter = (params.params && params.params.statusFilter) || "";

  let user = JSON.parse(localStorage.getItem("user"));
  let id = user.orgId;

  let filterParam = "";
  let statusFilterParam = "";
  if (filter) {
    filterParam = `&expenseType=${filter}`;
  }

  if (statusFilter) {
    statusFilterParam = `&status=${statusFilter}`;
  }

  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(
      `${appConfig.ip}/tripExpense/byuser?limit=10&page=${page}&ser=${search}${filterParam}${statusFilterParam}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_EXPENSE_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: actionTypes.FETCH_EXPENSE_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* approveexpense(value) {
  
  let id = value.data.id;
 
  // let data = value.data.status === "accepted";
  let data = value.data.status === "created" ? { status: "accepted" } : null;
  
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/tripExpense/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();
      yield toast.success("Expense approve successfully", {
        autoClose: 3000,
        className:"toastClass"
      });
      yield put({
        type: actionTypes.APPROVE_EXPENSE_SUCCESS_ACTION,
      });
      yield put({
        type: actionTypes.FETCH_EXPENSE_ACTION,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.APPROVE_EXPENSE_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* rejectexpense(value) {
  let id = value.data.id;
  let data = value.data.status === "created" ? { status: "rejected" } : null;

  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/tripExpense/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();
      yield toast.success("Expense rejected successfully", {
        autoClose: 3000,
        className:"toastClass"
      });
      yield put({
        type: actionTypes.REJECT_EXPENSE_SUCCESS_ACTION,
      });
      yield put({
        type: actionTypes.FETCH_EXPENSE_ACTION,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.REJECT_EXPENSE_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* fetchExpenseHeadInExpense() {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/expenseHead?isActive=true`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
      let expenseHead = resJSON.rows.map((data) => {
        let expenseHeads = {
          value: data.id,
          name: data.expenseType,
        };
        return expenseHeads;
      });

      yield put({
        type: actionTypes.FETCH_EXPENSE_HEAD_IN_EXPENSE_SUCCESS_ACTION,
        payload: resJSON,
        expenseHead: expenseHead,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_EXPENSE_HEAD_IN_EXPENSE_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

export function* expenseMapActionWatcher() {
  yield takeEvery(actionTypes.FETCH_EXPENSE_ACTION, fetchexpense);
  yield takeEvery(actionTypes.APPROVE_EXPENSE_ACTION, approveexpense);
  yield takeEvery(actionTypes.REJECT_EXPENSE_ACTION, rejectexpense);
  yield takeEvery(
    actionTypes.FETCH_EXPENSE_HEAD_IN_EXPENSE_ACTION,
    fetchExpenseHeadInExpense
  );
}
